import { render } from "./ModalBase.vue?vue&type=template&id=0a93238c&scoped=true&ts=true"
import script from "./ModalBase.vue?vue&type=script&lang=ts"
export * from "./ModalBase.vue?vue&type=script&lang=ts"

import "./ModalBase.vue?vue&type=style&index=0&id=0a93238c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a93238c"]])

export default __exports__